const TARGETING_MODE_LABELS = {
	contextual_only: "Contextual Criteria Only",
	without_third_party: "1st Party Criteria Only",
	full: "1st & 3rd Party Criteria",
};

export function formatTargetingMode(mode) {
	return TARGETING_MODE_LABELS[mode] || mode;
}
